export const createImgLoader = () => {
    const options = {
        rootMargin: '150px'
    };
    
    const preloadImg = (img) => {
        const src = img.getAttribute('data-src');
        if (!src) return;
    
        img.src = src;
    }
    
    const imageObserver = (entries, observer) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
                return
            } else {
                preloadImg(entry.target);
                observer.unobserve(entry.target)
            }
        })
    }

    try {
        const observer = new IntersectionObserver(imageObserver, options);
        const images = document.querySelectorAll('[data-src]')
        images.forEach(image => {
            observer.observe(image)
        })
    } catch (e) {}
}
